<template>
  <div>
    <nav
      class="navbar"
      role="navigation"
      aria-label="main navigation"
      v-if="$store.getters.isAuthenticated"
    >
      <div class="navbar-brand">

        <a
          role="button"
          class="navbar-burger burger"
          aria-label="menu"
          aria-expanded="false"
          data-target="navbarBasicExample"
        >
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </a>
      </div>

      <div class="navbar-menu">
        <div class="navbar-start">
          <router-link class="navbar-item" to="/home">Hem</router-link>
          <router-link class="navbar-item" to="/courses">Kurser</router-link>
          <router-link class="navbar-item" to="/customers">Kunder</router-link>
          <router-link class="navbar-item" to="/instructors"
            >Instruktörer</router-link
          >
          <router-link class="navbar-item" to="/settings"
            >Inställningar</router-link
          >
        </div>

        <div class="navbar-end">
          <div class="navbar-item">
            <div class="buttons">
              <a class="button is-light" @click="logout"> Log out </a>
            </div>
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  name: "NavBar",
  methods: {
    logout() {
      this.$store.dispatch("logout");
    },
  },
};
</script>

<style scoped>
.navbar {
  box-shadow: 0 0 0 1px #dfdfdf;
}
</style>